export default "__VITE_ASSET__DNYbPxIa__"